import {createStore} from 'vuex';

export default createStore({
    state: {
        posts: [
            {
                img: "/my-cv/img/mockup-pantogam.png",
                title: "My Amic",
                tags: {
                    year: "2017",
                    technology: ["Html", "Css", "Js"]
                },
                text_en: "Website development for the loyalty program and Amic discount cards in Ukraine.",
                text_ru: "Разработка сайта для программы лояльности и скидочных карт Amic в Украине.",
                url: "https://my.amicenergy.com.ua/index"
            },
            {
                img: "/my-cv/img/mockup-pantogam-2.png",
                title: "Landing",
                tags: {
                    year: "2017",
                    technology: ["Html", "Css", "Js"]
                },
                text_en: "Landing page development for a web studio.",
                text_ru: "Разработка лендинга для веб студии.",
                url: "https://brushteyn.github.io/landing/index.html"
            },
            {
                img: "/my-cv/img/mockup-pantogam-9.png",
                title: "Сайт Российского посольства в Китае",
                tags: {
                    year: "2017",
                    technology: ["Html", "Css", "Js"]
                },
                text_en: "Development of the website of the Russian Embassy in China.",
                text_ru: "Разработка сайта Российского посольства в Китае.",
                url: "http://www.russia.org.cn/en/"
            },
            {
                img: "/my-cv/img/mockup-pantogam-3.png",
                title: "Tech-Service",
                tags: {
                    year: "2018",
                    technology: ["Html", "Css", "Js"]
                },
                text_en: "Development of a landing page for a customer who is engaged in the repair of household appliances.",
                text_ru: "Разработка лендинга для заказчика который занимается ремонтом бытовой техники.",
                url: "https://brushteyn.github.io/tehno-service/index.html"
            },
            {
                img: "/my-cv/img/mockup-pantogam-4.png",
                title: "Landing",
                tags: {
                    year: "2018",
                    technology: ["Html", "Css", "Js"]
                },
                text_en: "Landing page development for a web studio.",
                text_ru: "Разработка лендинга для веб-студии.",
                url: "https://brushteyn.github.io/template/index.html"
            },
            {
                img: "/my-cv/img/mockup-pantogam-5.png",
                title: "Momat Rino",
                tags: {
                    year: "2018",
                    technology: ["Html", "Css", "Js"]
                },
                text_en: "Development of a site for advertising the drug Momat Rino from the common cold.",
                text_ru: "Разработка сайта рекламы препарата Момат Рино от насморка.",
                url: "https://brushteyn.github.io/momat-rino/index.html"
            },
            {
                img: "/my-cv/img/mockup-pantogam-6.png",
                title: "Walking Dead",
                tags: {
                    year: "2018",
                    technology: ["Html", "Css", "Js"]
                },
                text_en: "Development of a promo site for the new season of the Walking Dead series.",
                text_ru: "Разработка промосайта для нового сезона сериала Walking Dead.",
                url: "https://brushteyn.github.io/walking-dead/index.html"
            },
            {
                img: "/my-cv/img/mockup-pantogam-7.png",
                title: "Isec Management",
                tags: {
                    year: "2019",
                    technology: ["Html", "Css", "Js"]
                },
                text_en: "Landing page development for a web studio.",
                text_ru: "Разработка лендинга для веб-студии.",
                url: "https://brushteyn.github.io/isec/index.html"
            },
            {
                img: "/my-cv/img/mockup-pantogam-29.png",
                title: "DeepX",
                tags: {
                    year: "2019",
                    technology: ["Html", "Css", "Js"]
                },
                text_en: "Web studio.",
                text_ru: "Веб-студия.",
                url: "http://deepx.uz/"
            },
            {
                img: "/my-cv/img/mockup-pantogam-10.png",
                title: "TourHunter.com",
                tags: {
                    year: "2019",
                    technology: ["Html", "Css", "Js"]
                },
                text_en: "A powerful online B2B platform where tour and event providers can trade with agents, attract and meet new partners around the world, and get more online bookings.",
                text_ru: "Мощная онлайн-платформа B2B, где поставщики туров и мероприятий могут торговать с агентами, привлекать и знакомиться с новыми партнерами по всему миру и получать больше онлайн-заказов.",
                url: "https://pro.tourhunter.com/"
            },
            {
                img: "/my-cv/img/mockup-pantogam-8.png",
                title: "Orangerie",
                tags: {
                    year: "2020",
                    technology: ["Html", "Css", "Js"]
                },
                text_en: "Development of a landing page for a greenhouse in New York.",
                text_ru: "Разработка лендинга для оранжереи в Нью-Йорке.",
                url: "https://brushteyn.github.io/orangerie/index.html"
            },
            {
                img: "/my-cv/img/mockup-pantogam-11.png",
                title: "Resanta.ru",
                tags: {
                    year: "2020",
                    technology: ["Html", "Css", "Js"]
                },
                text_en: "RESANTA is the market leader in welding inverters and voltage stabilizers in Russia.",
                text_ru: "РЕСАНТА - лидер рынка сварочных инверторов и стабилизаторов напряжения в России.",
                url: "https://resanta.ru/"
            },
            {
                img: "/my-cv/img/mockup-pantogam-12.png",
                title: "Cents & Homes",
                tags: {
                    year: "2020",
                    technology: ["Html", "Css", "Js"]
                },
                text_en: "Cents'n'Homes is a young Munich company. Our mission is to make real estate investment easier for people all over Europe.",
                text_ru: "Cents'n'Homes - молодая Мюнхенская компания. Наша миссия - упростить инвестиции в недвижимость для людей во всей Европе.",
                url: "https://centsnhomes.com/ru"
            },
            {
                img: "/my-cv/img/mockup-pantogam-14.png",
                title: "Lan Game",
                tags: {
                    year: "2021",
                    technology: ["Html", "Css", "Js"]
                },
                text_en: "Gaming computer club in 1000 sq.m. in the center of Moscow.",
                text_ru: "Игровой компьютерный клуб в 1000 кв.м. в центре Москвы.",
                url: "https://brushteyn.github.io/langame/index.html"
            },
            {
                img: "/my-cv/img/mockup-pantogam-13.png",
                title: "Watch Town",
                tags: {
                    year: "2021",
                    technology: ["Html", "Css", "Js"]
                },
                text_en: "Online watch store.",
                text_ru: "Интернет магазин часов.",
                url: "https://brushteyn.github.io/watchtown/index.html"
            },
            {
                img: "/my-cv/img/mockup-pantogam-15.png",
                title: "ISEC Wealth Management",
                tags: {
                    year: "2021",
                    technology: ["Html", "Css", "Js"]
                },
                text_en: "Website for a company providing services in the financial sector.",
                text_ru: "Сайт для компании по предоставлению услуг в финансовой сфере.",
                url: "https://brushteyn.github.io/isec-management/index.html"
            },
            {
                img: "/my-cv/img/mockup-pantogam-16.png",
                title: "OOOGR",
                tags: {
                    year: "2021",
                    technology: ["Html", "Scss", "Js"]
                },
                text_en: "An esports platform for gamers by gamers.",
                text_ru: "Киберспортивная платформа для геймеров от геймеров.",
                url: "https://ooogr.com/"
            },
            {
                img: "/my-cv/img/mockup-pantogam-22.png",
                title: "IGM",
                tags: {
                    year: "2021",
                    technology: ["Html", "Scss", "Js"]
                },
                text_en: "The site of the largest gaming community in the CIS.",
                text_ru: "Сайт самого крупного игрового сообщества на просторах СНГ.",
                url: "https://igm.gg/"
            },
            {
                img: "/my-cv/img/mockup-pantogam-17.png",
                title: "mars.po.co",
                tags: {
                    year: "2021",
                    technology: ["Html", "Scss", "Js"]
                },
                text_en: "Clicker game created in honor of the release of the new phone company РОСО.",
                text_ru: "Игра кликер созданная в честь выхода нового телефона компании РОСО.",
                url: "http://poco.igm.gg/"
            },
            {
                img: "/my-cv/img/mockup-pantogam-18.png",
                title: "Xiaomi 11T",
                tags: {
                    year: "2021",
                    technology: ["Html", "Scss", "Js"]
                },
                text_en: "A series of games created in honor of the release of the new Xiaomi phone.",
                text_ru: "Серия игр созданная в честь выхода нового телефона компании Xiaomi.",
                url: "https://igm.gg/"
            },
            {
                img: "/my-cv/img/mockup-pantogam-21.png",
                title: "Call of Duty: Vanguard",
                tags: {
                    year: "2021",
                    technology: ["Html", "Scss", "Js"]
                },
                text_en: "Promo site dedicated to the release of the game Call of Duty: Vanguard and the distribution of beta keys.",
                text_ru: "Промо сайт посвященный выходу игры Call of Duty: Vanguard и раздаче бета ключей.",
                url: "https://igm.gg/"
            },
            {
                img: "/my-cv/img/mockup-pantogam-19.jpg",
                title: "Fikselburg",
                tags: {
                    year: "2022",
                    technology: ["Html", "Scss", "Js"]
                },
                text_en: "The largest enterprise in the Leningrad region in the production of metal structures and metalworking.",
                text_ru: "Самое крупное предприятие Ленинградской области в сфере производства металлоконструкций и металлообработки.",
                url: "http://fikselburg.ru/"
            },
            {
                img: "/my-cv/img/mockup-pantogam-20.png",
                title: "Poco",
                tags: {
                    year: "2022",
                    technology: ["Html", "Scss", "Js"]
                },
                text_en: "Promo game dedicated to the release of the new Poco phone.",
                text_ru: "Промо игра посвященная выходу нового телефона компании Poco.",
                url: "https://poco-ace.igm.gg/"
            },
            {
                img: "/my-cv/img/mockup-pantogam-23.png",
                title: "INXY.COM",
                tags: {
                    year: "2022",
                    technology: ["Html", "Scss", "VueJs"]
                },
                text_en: "Service for searching and managing subscriptions.",
                text_ru: "Сервис для поиска и управления подписками.",
                url: "https://inxy.com/"
            },
            {
                img: "/my-cv/img/mockup-pantogam-24.png",
                title: "BLUE-ANT.RU",
                tags: {
                    year: "2022",
                    technology: ["Html", "Stylus", "VueJs"]
                },
                text_en: "Web studio with over 10 years of experience and over 100 completed complex projects.",
                text_ru: "Веб студия с опытом более 10 лет и более 100 реализованных сложных проектов.",
                url: "https://blue-ant.ru/"
            },
            {
                img: "/my-cv/img/mockup-pantogam-25.png",
                title: "One Visit Solution",
                tags: {
                    year: "2022",
                    technology: ["Html", "Css"]
                },
                text_en: "Site for the sale of building materials in Greece.",
                text_ru: "Сайт по продаже стройматериалов в греции.",
                url: "https://onevisit.com/"
            },
            {
                img: "/my-cv/img/mockup-pantogam-26.png",
                title: "Tau House",
                tags: {
                    year: "2022",
                    technology: ["Html", "Stylus", "VueJs"]
                },
                text_en: "Builder website.",
                text_ru: "Сайт застройщика.",
                url: "https://tauhouse.ru/"
            },
            {
                img: "/my-cv/img/mockup-pantogam-27.png",
                title: "Петрович",
                tags: {
                    year: "2022",
                    technology: ["Html", "Stylus", "Js"]
                },
                text_en: "Builder website.",
                text_ru: "Сайт застройщика.",
                url: "https://petrovich.ru/"
            },
            {
                img: "/my-cv/img/mockup-pantogam-28.png",
                title: "Afisha.uz",
                tags: {
                    year: "2022",
                    technology: ["Html", "Css", "Js"]
                },
                text_en: "Afisha.uz is the largest Uzbek portal for providing information services in the field of culture, entertainment and leisure.",
                text_ru: "Afisha.uz является крупнейшим узбекским порталом по предоставлению информационных сервисов в сфере культуры, развлечения и досуга.",
                url: "https://www.afisha.uz/ru"
            },
            {
                img: "/my-cv/img/mockup-pantogam-30.png",
                title: "M5 House",
                tags: {
                    year: "2022",
                    technology: ["Html", "Stylus", "VueJs"]
                },
                text_en: "Builder website.",
                text_ru: "Сайт застройщика.",
                url: "https://m5.house/"
            },
            {
                img: "/my-cv/img/mockup-pantogam-31.png",
                title: "Тетрис - Семейный Компаунд",
                tags: {
                    year: "2022",
                    technology: ["Html", "Stylus", "VueJs"]
                },
                text_en: "Builder website.",
                text_ru: "Сайт застройщика.",
                url: "https://tetris-kvartal.ru/"
            },
            {
                img: "/my-cv/img/mockup-pantogam-32.png",
                title: "Terle Park",
                tags: {
                    year: "2022",
                    technology: ["Pug", "Stylus", "JQuery"]
                },
                text_en: "Official website of the residential complex in Ufa.",
                text_ru: "Официальный сайт жилого комплекса в Уфе.",
                url: "https://terlepark.ru/"
            },
            {
                img: "/my-cv/img/mockup-pantogam-33.png",
                title: "ОДСК",
                tags: {
                    year: "2023",
                    technology: ["VueJS", "Sass"]
                },
                text_en: "Official website of the residential complex in Moscow.",
                text_ru: "Официальный сайт жилого комплекса в Москве.",
                url: "https://orelstroy.ru/"
            },
            {
                img: "/my-cv/img/mockup-pantogam-34.png",
                title: "Остров РФ",
                tags: {
                    year: "2023",
                    technology: ["VueJS", "Sass"]
                },
                text_en: "Official website of the residential complex in Moscow.",
                text_ru: "Официальный сайт жилого комплекса в Москве.",
                url: "https://xn--b1axaheg.xn--p1ai/"
            },
            {
                img: "/my-cv/img/mockup-pantogam-35.png",
                title: "Savin Family",
                tags: {
                    year: "2023",
                    technology: ["VueJS", "Sass"]
                },
                text_en: "Official website of the residential complex in Moscow.",
                text_ru: "Официальный сайт жилого комплекса в Москве.",
                url: "https://savin-family.ru/"
            },
            {
                img: "/my-cv/img/mockup-pantogam-36.png",
                title: "Atlant Tennis",
                tags: {
                    year: "2023",
                    technology: ["VueJS", "Sass"]
                },
                text_en: "The official site of Atlant Tennis complexes in Moscow, where tennis is taught.",
                text_ru: "Официальный сайт Atlant Tennis комплексов в Москве, где обучают большому теннису.",
                url: "https://atlanttennis.ru/"
            },
            {
                img: "/my-cv/img/mockup-pantogam-37.png",
                title: "CITY 21",
                tags: {
                    year: "2023",
                    technology: ["VueJS", "Sass"]
                },
                text_en: "Official website of the residential complex in Moscow.",
                text_ru: "Официальный сайт жилого комплекса в Москве.",
                url: "https://city-xxi.ru/"
            },
            {
                img: "/my-cv/img/mockup-pantogam-38.png",
                title: "Dobrofura",
                tags: {
                    year: "2023",
                    technology: ["AngularJS", "Sass"]
                },
                text_en: "Website for the DobroFON charity program.",
                text_ru: "Сайт для благотворительной программы ДоброФОН.",
                url: "https://xn--80abi4bblbxi.xn--p1ai/west-wagon"
            },
            {
                img: "/my-cv/img/mockup-pantogam-39.png",
                title: "LOKO Legends",
                tags: {
                    year: "2023",
                    technology: ["AngularJS", "Sass"]
                },
                text_en: "Complete tasks in the world of Lokopunk, assemble a team of Lokomotiv legends and win free bets or exclusive merch!",
                text_ru: "Выполняй задания в мире Локопанка, собирай команду из легенд Локомотива и выигрывай фрибеты или эксклюзивный мерч!",
                url: "https://loco-legends.igm.gg/#/auth/login"
            },
            {
                img: "/my-cv/img/mockup-pantogam-40.png",
                title: "Ashan game",
                tags: {
                    year: "2023",
                    technology: ["AngularJS", "Sass"]
                },
                text_en: "New Year's cuisine. Game for the AUCHAN application.",
                text_ru: "Новогодняя кухня. Игра для приложения АШАН.",
                url: "https://m.vk.com/wall-53736046_121878?post_add"
            },
            {
                img: "/my-cv/img/mockup-pantogam-41.png",
                title: "Лоськов game",
                tags: {
                    year: "2024",
                    technology: ["AngularJS", "Sass"]
                },
                text_en: "A browser/mobile game dedicated to the birthday of football player Dmitry Loskov.",
                text_ru: "Браузерная/мобильная игра приуроченная к дню рождению футболиста Дмитрия Лоськова.",
                url: "https://www.fclm.ru/news/n/igra-fonbet-loskov/"
            },
            {
                img: "/my-cv/img/mockup-pantogam-42.png",
                title: "Крикет game",
                tags: {
                    year: "2024",
                    technology: ["AngularJS", "Sass"]
                },
                text_en: "A cricket browser/mobile game.",
                text_ru: "Браузерная/мобильная игра крикет.",
                url: "https://savetheleague.batery.ai/#/"
            },
            {
                img: "/my-cv/img/mockup-pantogam-43.png",
                title: "Собираем чемоданы",
                tags: {
                    year: "2024",
                    technology: ["AngularJS", "Sass"]
                },
                text_en: "Browser/mobile game. Game for the AUCHAN application.",
                text_ru: "Браузерная/мобильная игра. Игра для приложения АШАН.",
                url: "https://dzen.ru/a/ZkYdDBQ5kUeo7Svk"
            },
            {
                img: "/my-cv/img/mockup-pantogam-44.png",
                title: "UFC",
                tags: {
                    year: "2024",
                    technology: ["AngularJS", "Sass"]
                },
                text_en: "Browser/mobile game.",
                text_ru: "Браузерная/мобильная игра.",
                url: "https://playforpuja.batery.ai/#/"
            },
            {
                img: "/my-cv/img/mockup-pantogam-45.png",
                title: "Selfstoy",
                tags: {
                    year: "2024",
                    technology: ["Pug", "Sass"]
                },
                text_en: "Builder website.",
                text_ru: "Сайт для застройщика.",
                url: "#"
            },
            {
                img: "/my-cv/img/mockup-pantogam-46.png",
                title: "Ashan game",
                tags: {
                    year: "2024",
                    technology: ["AngularJS", "Sass"]
                },
                text_en: "Browser/mobile game. Game for the AUCHAN application.",
                text_ru: "Браузерная/мобильная игра. Игра для приложения АШАН.",
                url: "#"
            },
            {
                img: "/my-cv/img/mockup-pantogam-47.png",
                title: "IGM game",
                tags: {
                    year: "2024",
                    technology: ["ReactJS", "Sass"]
                },
                text_en: "Browser/mobile game. Game for IGM.",
                text_ru: "Браузерная/мобильная игра. Игра для IGM.",
                url: "#"
            },
            {
                img: "/my-cv/img/mockup-pantogam-48.png",
                title: "СибДев",
                tags: {
                    year: "2024",
                    technology: ["Pug", "Sass"]
                },
                text_en: "Builder website.",
                text_ru: "Сайт для застройщика.",
                url: "#"
            },
            {
                img: "/my-cv/img/mockup-pantogam-49.png",
                title: "Дорога Ярости",
                tags: {
                    year: "2024",
                    technology: ["Angular", "Sass"]
                },
                text_en: "Browser/mobile game.",
                text_ru: "Браузерная/мобильная игра.",
                url: "#"
            },
            {
                img: "/my-cv/img/mockup-pantogam-50.png",
                title: "Anni Blasters",
                tags: {
                    year: "2024",
                    technology: ["Angular", "Sass"]
                },
                text_en: "Browser/mobile game.",
                text_ru: "Браузерная/мобильная игра.",
                url: "#"
            },
            {
                img: "/my-cv/img/mockup-pantogam-51.png",
                title: "Ashan New Year 2025",
                tags: {
                    year: "2024",
                    technology: ["Angular", "Sass"]
                },
                text_en: "Browser/mobile game. Game for the AUCHAN application.",
                text_ru: "Браузерная/мобильная игра. Игра для приложения АШАН.",
                url: "#"
            },
            {
                img: "/my-cv/img/mockup-pantogam-52.png",
                title: "ДомКор",
                tags: {
                    year: "2024",
                    technology: ["VueNuxt", "Sass"]
                },
                text_en: "Builder website.",
                text_ru: "Сайт для застройщика.",
                url: "#"
            },
            {
                img: "/my-cv/img/mockup-pantogam-53.png",
                title: "КМ Печерский",
                tags: {
                    year: "2024",
                    technology: ["VueNuxt", "Sass"]
                },
                text_en: "Builder website.",
                text_ru: "Сайт для застройщика.",
                url: "#"
            },
            {
                img: "/my-cv/img/mockup-pantogam-54.png",
                title: "Проспект",
                tags: {
                    year: "2024",
                    technology: ["Pug", "Sass"]
                },
                text_en: "Builder website.",
                text_ru: "Сайт для застройщика.",
                url: "#"
            },
            {
                img: "/my-cv/img/mockup-pantogam-55.png",
                title: "Нанобрендинг",
                tags: {
                    year: "2024",
                    technology: ["Pug", "Sass"]
                },
                text_en: "Website.",
                text_ru: "Сайт.",
                url: "#"
            },
            {
                img: "/my-cv/img/mockup-pantogam-56.png",
                title: "IGM steam",
                tags: {
                    year: "2024",
                    technology: ["Angular", "Sass"]
                },
                text_en: "IGM steam.",
                text_ru: "IGM steam.",
                url: "#"
            },
            {
                img: "/my-cv/img/mockup-pantogam-57.png",
                title: "IGM game",
                tags: {
                    year: "2024",
                    technology: ["React", "Sass"]
                },
                text_en: "IGM game.",
                text_ru: "IGM game.",
                url: "#"
            },
            {
                img: "/my-cv/img/mockup-pantogam-58.png",
                title: "Виват",
                tags: {
                    year: "2025",
                    technology: ["Pug", "Sass"]
                },
                text_en: "Builder website.",
                text_ru: "Сайт для застройщика.",
                url: "#"
            },
            {
                img: "/my-cv/img/mockup-pantogam-59.png",
                title: "Ashan game",
                tags: {
                    year: "2025",
                    technology: ["AngularJS", "Sass"]
                },
                text_en: "Browser/mobile game. Game for the AUCHAN application.",
                text_ru: "Браузерная/мобильная игра. Игра для приложения АШАН.",
                url: "#"
            },
            {
                img: "/my-cv/img/mockup-pantogam-60.png",
                title: "IGM project",
                tags: {
                    year: "2025",
                    technology: ["AngularJS", "Sass"]
                },
                text_en: "IGM project",
                text_ru: "Сайт для продажи билетов на ивент.",
                url: "#"
            },
            {
                img: "/my-cv/img/mockup-pantogam-61.png",
                title: "IGM project",
                tags: {
                    year: "2025",
                    technology: ["AngularJS", "Sass"]
                },
                text_en: "Landing and game to 20 years of CSKA command and euro cup.",
                text_ru: "Лендинг и игра на 20 летие команды ЦСКА и первый еврокубок.",
                url: "#"
            },
            {
                img: "/my-cv/img/mockup-pantogam-62.png",
                title: "Selfstroy landing",
                tags: {
                    year: "2025",
                    technology: ["Pug", "Sass"]
                },
                text_en: "Selfstroy landing.",
                text_ru: "Selfstroy лендинг.",
                url: "#"
            },
            {
                img: "/my-cv/img/mockup-pantogam-63.png",
                title: "IGM game",
                tags: {
                    year: "2025",
                    technology: ["AngularJS", "Sass"]
                },
                text_en: "IGM game.",
                text_ru: "IGM игра.",
                url: "#"
            },
            {
                img: "/my-cv/img/mockup-pantogam-64.png",
                title: "Ashan game",
                tags: {
                    year: "2025",
                    technology: ["AngularJS", "Sass"]
                },
                text_en: "Ashan game.",
                text_ru: "Ashan игра.",
                url: "#"
            },
            {
                img: "/my-cv/img/mockup-pantogam-65.png",
                title: "INZOI",
                tags: {
                    year: "2025",
                    technology: ["AngularJS", "Sass"]
                },
                text_en: "INZOI.",
                text_ru: "INZOI.",
                url: "#"
            },
            {
                img: "/my-cv/img/mockup-pantogam-66.png",
                title: "Fonbet Landing",
                tags: {
                    year: "2025",
                    technology: ["AngularJS", "Sass"]
                },
                text_en: "Fonbet Landing.",
                text_ru: "Fonbet Landing.",
                url: "#"
            },
            {
                img: "/my-cv/img/mockup-pantogam-67.png",
                title: "Divnoe",
                tags: {
                    year: "2025",
                    technology: ["Jad", "Sass"]
                },
                text_en: "Builder website.",
                text_ru: "Сайт для застройщика.",
                url: "#"
            },
            {
                img: "/my-cv/img/mockup-pantogam-68.png",
                title: "FSK",
                tags: {
                    year: "2025",
                    technology: ["Vue", "Sass"]
                },
                text_en: "Builder website.",
                text_ru: "Сайт для застройщика.",
                url: "#"
            },
            {
                img: "/my-cv/img/mockup-pantogam-69.png",
                title: "Aristov Bereg",
                tags: {
                    year: "2025",
                    technology: ["Vue", "Sass"]
                },
                text_en: "Builder website.",
                text_ru: "Сайт для застройщика.",
                url: "#"
            },
            {
                img: "/my-cv/img/mockup-pantogam-70.png",
                title: "CSX",
                tags: {
                    year: "2025",
                    technology: ["Vue", "Sass"]
                },
                text_en: "Builder website.",
                text_ru: "Сайт для застройщика.",
                url: "#"
            },
            {
                img: "/my-cv/img/mockup-pantogam-71.png",
                title: "KM Timiryazevskiy",
                tags: {
                    year: "2025",
                    technology: ["Vue", "Sass"]
                },
                text_en: "Builder website.",
                text_ru: "Сайт для застройщика.",
                url: "#"
            },
            {
                img: "/my-cv/img/mockup-pantogam-72.png",
                title: "Ashan New Year 2026",
                tags: {
                    year: "2025",
                    technology: ["Angular", "Sass"]
                },
                text_en: "Browser/mobile game. Game for the ASHAN application.",
                text_ru: "Браузерная/мобильная игра. Игра для приложения АШАН.",
                url: "#"
            },
            {
                img: "/my-cv/img/mockup-pantogam-73.png",
                title: "HSR v4.0",
                tags: {
                    year: "2025",
                    technology: ["Angular", "Sass"]
                },
                text_en: "Browser/mobile game. Game for the ASHAN application.",
                text_ru: "Браузерная/мобильная игра. Игра для приложения АШАН.",
                url: "#"
            },
            {
                img: "/my-cv/img/mockup-pantogam-74.png",
                title: "ЖК Союз",
                tags: {
                    year: "2025",
                    technology: ["Vue", "Sass"]
                },
                text_en: "Builder website.",
                text_ru: "Сайт для застройщика.",
                url: "#"
            },
            {
                img: "/my-cv/img/mockup-pantogam-75.png",
                title: "Donstroy",
                tags: {
                    year: "2026",
                    technology: ["Vue", "Sass"]
                },
                text_en: "Builder website.",
                text_ru: "Сайт для застройщика.",
                url: "#"
            },
            {
                img: "/my-cv/img/mockup-pantogam-76.png",
                title: "Gagarin Park",
                tags: {
                    year: "2026",
                    technology: ["Vue", "Sass"]
                },
                text_en: "Builder website.",
                text_ru: "Сайт для застройщика.",
                url: "#"
            },
        ]
    }
});